function getProducts(items) {
    var products = [];
    for(var item of items) {
        var product = $.ajax({dataType: "json", url: '/products/' + item.handle + '.js', async: false}).responseJSON;
        if (product) products.push(product);
    }
    return products;
}

function isReservationProduct(product) {
    var result = false;
    for(var tag of product['tags']) {
        if (tag === 'reserved') {
            result = true;
            break;
        }
    }
    return result;
}

function filterReservationProducts(products) {
    var results = [];
    for (var product of products) {
        if (isReservationProduct(product)) results.push(product);
    }
    return results;
}

// 閲覧中のページの商品をカートに追加できる場合はtrue
function checkEnableAddToCart() {

    //予約商品の場合はtrue
    var isReservation = $('#reservation').data("reservation") === true;
    var cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;

    var result = false;
    if (cartItems) {
        var products = getProducts(cartItems);
        var reservationProducts = filterReservationProducts(products);

        //予約商品を含んでいる場合はtrue
        var includeReservationItem = reservationProducts.length > 0

        /**
         * 以下いずれかに該当する場合はtrue
         * - 予約商品ではない && 予約商品を含まない
         * - 予約商品である && 予約商品を含む
         * - カート内の商品が0個
         */
        result = isReservation === includeReservationItem || products.length === 0
    }
    return result;
}

function checkCartItems() {
    var cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;
    var result = true;

    if (cartItems) {
        var products = getProducts(cartItems);
        var reservationProducts = filterReservationProducts(products);

        if(reservationProducts.length) {
            result = reservationProducts.length === cartItems.length
        }
    }

    if(!result) {
        alert('予約商品と通常商品を同時に購入することが出来ません');
    }

    return result;
}

var $addToCartButton = $('#addToCartButton');
if($addToCartButton.length) {
    $addToCartButton.click(function() {
        const result = checkEnableAddToCart()
        if(!result) {
            alert("予約商品と通常商品を同時にカートに入れることは出来ません");
        }
        return result;
    });
}